import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  ButtonWithLoader,
  PageWrapper,
  Paper,
  PaperTitle,
  FormWrapper,
  RFFormSelect,
} from 'virtues-bootstrap';

import { ReactComponent as IconFileUpload } from 'svg/file-upload-solid.svg';
import Dropzone from 'react-dropzone';
import { CVI_TYPES } from 'constants/medical';
import DatePicker from 'components/ui/DatePicker';
import AdaptiveDataRow from 'components/DataBlock/AdaptiveDataRow';

import s from './styles.module.scss';

const contentSizes = {
  md: 12,
  lg: 9,
};

const titleSizes = {
  xs: 4,
  lg: 3,
};

const contentSizesTypes = {
  xs: 8,
  lg: 4,
};

const titleSizesTypes = {
  xs: 4,
  lg: 3,
};

class UploadCardioReport extends PureComponent {
  static propTypes = {
    parsePdf: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };
  }

  onDropAccepted = files => {
    const { parsePdf } = this.props;
    const [file] = files;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = event => {
      this.setState({ dragAndDropError: null });
      this.setState({ files: [{ name: file.name, base64: event.target.result }] });
      parsePdf({ file: event.target.result });
    };
  };

  onDropRejected = () => {
    this.setState({ dragAndDropError: 'reports.dragAndDropErrorOnlyPdf' });
  };

  render() {
    const { pristine, submitting, t, handleSubmit } = this.props;

    const { files, dragAndDropError } = this.state;

    return (
      <form onSubmit={handleSubmit}>
        <PageWrapper tight>
          <Paper>
            <PaperTitle withBorder>{t('reports.newCardioReport')}</PaperTitle>
            <FormWrapper title={t('reports.uploadNewReport')}>
              <AdaptiveDataRow
                titleSizes={titleSizesTypes}
                contentSizes={contentSizesTypes}
                withLabelMargin
                title={t('reports.reportType')}
              >
                <Field
                  className={s.field}
                  name="type"
                  component={RFFormSelect}
                  placeholder={t('reports.reportType')}
                >
                  {CVI_TYPES.map(type => (
                    <option key={type} value={type}>
                      {t(`cardiovascularInvestigations.${type}`)}
                    </option>
                  ))}
                </Field>
              </AdaptiveDataRow>
              <AdaptiveDataRow
                titleSizes={titleSizesTypes}
                contentSizes={contentSizesTypes}
                withLabelMargin
                title={t('reports.reportDate')}
              >
                <Field
                  className={s.field}
                  name="reportDate"
                  component={DatePicker}
                  placeholder={t('reports.reportDate')}
                />
              </AdaptiveDataRow>
              <AdaptiveDataRow titleSizes={titleSizes} contentSizes={contentSizes}>
                <Dropzone
                  onDropAccepted={this.onDropAccepted}
                  onDropRejected={this.onDropRejected}
                  accept="application/pdf"
                  multiple={false}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <div {...getRootProps({ className: 'dropzone' })} data-test="dropZone">
                        <input {...getInputProps()} />
                        <p>{t('reports.dragAndDropReportFile')}.</p>
                      </div>
                      <aside>
                        {dragAndDropError && (
                          <div className={s.fieldError}>{t(dragAndDropError)}</div>
                        )}
                        {files.map(({ name }) => (
                          <p key={name}>{name}</p>
                        ))}
                      </aside>
                    </section>
                  )}
                </Dropzone>
                <ButtonWithLoader
                  className={s.uploadBtn}
                  icon={<IconFileUpload />}
                  type="sumbit"
                  onChange={() => {}}
                  outlined
                  variant="primary"
                  disabled={pristine || !files.length}
                  loading={submitting}
                >
                  {t('reports.uploadReport')}
                </ButtonWithLoader>
              </AdaptiveDataRow>
            </FormWrapper>
          </Paper>
        </PageWrapper>
      </form>
    );
  }
}

export default UploadCardioReport;
